import { handleActions } from 'redux-actions';
import { socketsResetAction } from 'store/actions/sockets';
import { socketsStoreNewNotificationAction } from 'store/actions/sockets/notifications';
import {
  emptyNotificationAction,
  requestGetNotificationAction,
  requestMarkNotificationAsClearedAction,
  requestMarkNotificationAsReadAction,
  requestMarkNotificationToggleAction,
} from 'store/actions/notifications';
import { cloneDeep, get } from 'lodash-es';
import { IDLE, PENDING } from 'settings/constants/apiState';

const initialData = {
  items: [],
  hasNextPage: false,
  nextCursor: null,
  loadingState: IDLE,
  pinned: false,
};

export default handleActions(
  {
    [socketsStoreNewNotificationAction]: (state, { payload }) => {
      const newNotification = get(payload, 'data', {});
      return {
        ...state,
        items: [newNotification, ...state.items],
      };
    },
    [requestMarkNotificationToggleAction]: (state, { payload }) => {
      const Id = get(payload, 'Id');
      const toggle = get(payload, 'toggle');
      const pinned = get(payload, 'pinned');
      const clonedNotifications = cloneDeep(state.items);
      const updatedNotificationIndex = state.items.findIndex(
        (notification) => notification?.Id === Id,
      );
      if (updatedNotificationIndex !== -1) {
        if (pinned) {
          clonedNotifications.splice(updatedNotificationIndex, 1);
        } else {
          clonedNotifications[updatedNotificationIndex].IsPinned = toggle;
        }
      }
      return {
        ...state,
        items: clonedNotifications,
      };
    },
    [requestGetNotificationAction]: (state, { payload }) => {
      const newItems = get(payload, 'data.items', []);
      const hasNextPage = get(payload, 'data.hasNextPage', false);
      const nextCursor = get(payload, 'data.nextCursor', null);
      const loadingState = get(payload, 'state');
      const pinned = get(payload, 'meta.pinned', false);
      return loadingState === PENDING
        ? {
            ...state,
            loadingState,
          }
        : {
            ...state,
            items: payload?.meta?.cursor ? [...state.items, ...newItems] : newItems,
            hasNextPage,
            nextCursor,
            loadingState,
            pinned,
          };
    },
    [emptyNotificationAction]: (state) => {
      return {
        ...state,
        items: [],
      };
    },
    [requestMarkNotificationAsReadAction]: (state, { payload }) => {
      const updatedNotifications = get(payload, 'data', []);
      const clonedItems = cloneDeep(state.items);

      updatedNotifications?.forEach((notification) => {
        const index = clonedItems.findIndex((item) => item?.Id === notification?.Id);
        if (index !== -1) {
          clonedItems[index] = notification;
        }
      });

      return {
        ...state,
        items: clonedItems,
      };
    },
    [requestMarkNotificationAsClearedAction]: (state, { payload }) => {
      const Ids = get(payload, 'Ids', []);
      const filteredNotifications = state.items.filter(
        (notification) => !Ids.includes(notification?.Id),
      );
      return {
        ...state,
        items: filteredNotifications,
      };
    },
    [socketsResetAction]: () => initialData,
  },
  initialData,
);
